import { ChangeDetectionStrategy, Component } from "@angular/core";
import {
  IonIcon,
  IonLabel,
  IonRouterLink,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/angular/standalone";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-tabs",
  imports: [
    IonTabs,
    RouterLink,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel,
    IonRouterLink,
],
  template: `
    <ion-tabs>
      <ion-tab-bar slot="bottom">
        <ion-tab-button
          tab="company"
          [routerLink]="['company']"
        >
          <ion-icon name="business-outline"></ion-icon>
          <ion-label>Company</ion-label>
        </ion-tab-button>
        <ion-tab-button
          tab="certificates"
          [routerLink]="['certificates']"
        >
          <ion-icon name="document-outline"></ion-icon>
          <ion-label>Certificates</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent {}
